<template>
  <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page" id="app">

    <Loading v-if="$root.loading"></Loading>
    <router-view v-else></router-view>

  </div>
</template>

<script>
import Loading from './components/Loading.vue';

export default {
  name: 'App',
  components: {
    Loading,
  },
};
</script>

<style>

</style>
